import { Stack, Typography } from '@mui/material'

import { FIELD_HEIGHT, Switch } from '@repo/ui'

interface ToggleFieldProps {
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
  /** Typography variant for the label. Defaults to body2 (matches the other fields). */
  labelVariant?: 'body1' | 'body2' | 'body3' | 'body4'
}

/**
 * A boolean form/filter field shaped like the rest of the fields: the label sits ON
 * TOP and the toggle sits BELOW in a field-height (FIELD_HEIGHT, 49px) row, so a Switch lines up with
 * inputs / sliders / date pickers (e.g. in the Filters drawer). Reusable — replaces the
 * ad-hoc `FormControlLabel` / inline `Stack + Switch` copies (Owners, Certificates, …).
 */
export const ToggleField = ({ label, checked, onChange, labelVariant = 'body2' }: ToggleFieldProps) => (
  <Stack spacing={2}>
    <Typography variant={labelVariant}>{label}</Typography>
    <Stack sx={{ minHeight: FIELD_HEIGHT }} justifyContent="center">
      <Switch checked={checked} onChange={(e) => onChange(e.target.checked)} />
    </Stack>
  </Stack>
)
